import React from 'react'
import { Box, Container } from '@mui/material'

function TextContainer({children, customStyles}) {
    return (
        <Box sx={{...customStyles}} marginX={3}>
            {children}
        </Box>
    )
}

export default TextContainer